import React from 'react';
import { useSharedCart } from '../../entrypoints/theme';

const SavingValue = () => {
  const { cartState } = useSharedCart();
  // Format the savings value to ensure two decimal places
  const formattedSavings = Number(cartState?.main_items_savings || 0).toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  return (
    <span>${formattedSavings}</span> // Use the formatted value
  );
};

export default SavingValue;
